import React from 'react';

export default class NavBar extends React.Component {

	static contextTypes = {
		setNavBarTitle: React.PropTypes.func,
		setNavBarButtons: React.PropTypes.func,
		setNavBarHomeButton: React.PropTypes.func
	};

	constructor(props) {
		super(props);
		this.onBackKeyDownListener = this.onBackKeyDown.bind(this);
	}

	componentWillMount() {
		this.context.setNavBarTitle(this.props.title);
		this.context.setNavBarButtons(this.props.buttons);
		this.context.setNavBarHomeButton({onClick: this.props.onClose});
	}

	componentDidMount() {
		document.addEventListener("backbutton", this.onBackKeyDownListener);
	}

	componentWillUnmount() {
		document.removeEventListener("backbutton", this.onBackKeyDownListener);
	}

	onBackKeyDown() {
		this.props.onClose();
	}

	render() {
		return false;
	}
}




// WEBPACK FOOTER //
// ./src/components/NavBar.js